import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

/** Token-aware className combiner (clsx + tailwind-merge). */
export function cn(...inputs) {
  return twMerge(clsx(inputs));
}
